import { render, staticRenderFns } from "./DownloadTemplate.vue?vue&type=template&id=210896e8&scoped=true"
import script from "./DownloadTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadTemplate.vue?vue&type=script&lang=js"
import style0 from "./DownloadTemplate.vue?vue&type=style&index=0&id=210896e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210896e8",
  null
  
)

export default component.exports